import { Box, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { notificationApi } from 'hooks/api/notification'
import { convertToLink } from 'hooks/helper/link'
import NotificationFilesComponent from 'pages/notification/components/notificationFiles'
import { notificationStatus, Notification } from 'types/notification'

export default function AnnouncementPage() {
  const { t } = useTranslation(['page-notification', 'common'])
  const { id } = useParams<{ id: string }>()
  const [announcement, setAnnouncement] = useState<Notification>()
  const fetchData = useCallback(() => {
    notificationApi()
      .findById(id!)
      .then((res) => {
        setAnnouncement(res.data)
        if (res.data.status === notificationStatus.Notified) {
          notificationApi().readed(id!)
        }
      })
  }, [id])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <Box
      sx={{
        padding: '16px',
        maxWidth: '600px',
        margin: '0 auto',
        backgroundColor: '#fff',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px',
        }}
      >
        <Box
          sx={{
            display: 'inline-block',
            padding: '4px 8px',
            backgroundColor: '#D3D3D3',
            borderRadius: '4px',
            fontWeight: 'bold',
            color: '#fff',
            fontSize: '14px',
            textAlign: 'center',
            marginRight: '8px',
          }}
        >
          {t('labels.announcement')}
        </Box>

        <Typography
          variant="body2"
          sx={{
            color: '#666',
            fontSize: '14px',
            marginRight: 'auto',
          }}
        >
          {announcement?.sentAt &&
            announcement.sentAt.format(
              t('common:date_format.date_with_day_time'),
            )}
        </Typography>
      </Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          marginBottom: '16px',
          borderBottom: '1px solid #A0A0A0',
          padding: 2,
        }}
      >
        {announcement?.title}
      </Typography>

      <Typography
        variant="h5"
        sx={{ whiteSpace: 'pre-line', marginBottom: '16px', padding: 2 }}
        dangerouslySetInnerHTML={{
          __html: convertToLink(announcement?.content || ''),
        }}
      ></Typography>

      {/* 関連資料 */}
      <NotificationFilesComponent
        files={announcement?.notificationFiles || []}
      />
    </Box>
  )
}
